import { useQuery } from "@tanstack/react-query";
import { fetchDevLeaderboard } from "./api";
import { getClientId } from "./clientId";

const MIN_HIT_RATE = 40; // % of their coins that ran >=2x
const MIN_COINS = 2;

// Returns a map of creator wallet -> { name, hitRate, coins } for the user's
// high-hit-rate tracked devs, so the Radar can badge their fresh launches.
export const useProvenDevs = () => {
  const clientId = getClientId();
  const { data } = useQuery({
    queryKey: ["devLeaderboard", clientId],
    queryFn: () => fetchDevLeaderboard(clientId),
    refetchInterval: 300000,
    staleTime: 120000,
  });
  const map = {};
  for (const d of data?.devs || []) {
    if (!d.hasData || d.hitRate < MIN_HIT_RATE || d.coins < MIN_COINS) continue;
    for (const w of d.wallets || []) {
      map[w] = { name: d.name, hitRate: d.hitRate, coins: d.coins };
    }
  }
  const provenFor = (creator) => (creator ? map[creator] || null : null);
  return { provenFor };
};
